var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0256 22H5.97436C3.78462 22 2 20.2091 2 18.0116V6.98835C2 4.7909 3.78462 3 5.97436 3H18.0256C20.2154 3 22 4.7909 22 6.98835V18.0116C22 20.2091 20.2154 22 18.0256 22ZM5.97436 4.54388C4.63077 4.54388 3.53846 5.64003 3.53846 6.98835V18.0116C3.53846 19.36 4.63077 20.4561 5.97436 20.4561H18.0256C19.3692 20.4561 20.4615 19.36 20.4615 18.0116V6.98835C20.4615 5.64003 19.3692 4.54388 18.0256 4.54388H5.97436Z",
    fill: "#677179"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97435 4.09766H18.0256C19.7949 4.09766 21.2308 5.51287 21.2308 7.25662V10.082H2.76923V7.25662C2.76923 5.51287 4.20512 4.09766 5.97435 4.09766Z",
    fill: "#98C8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2308 10.8405H2.76923C2.34359 10.8405 2 10.5018 2 10.0823V7.25695C2 5.09875 3.78462 3.33984 5.97436 3.33984H18.0256C20.2154 3.33984 22 5.09875 22 7.25695V10.0823C22 10.5018 21.6564 10.8405 21.2308 10.8405ZM3.53846 9.32418H20.4615V7.25695C20.4615 5.93272 19.3692 4.85614 18.0256 4.85614H5.97436C4.63077 4.85614 3.53846 5.93272 3.53846 7.25695V9.32418Z",
    fill: "#677179"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7128 6.28608C6.28716 6.28608 5.94357 5.94744 5.94357 5.52793V2.75815C5.94357 2.33864 6.28716 2 6.7128 2C7.13844 2 7.48203 2.33864 7.48203 2.75815V5.52793C7.48203 5.94744 7.13844 6.28608 6.7128 6.28608Z",
    fill: "#677179"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2872 6.28608C16.8615 6.28608 16.5179 5.94744 16.5179 5.52793V2.75815C16.5179 2.33864 16.8615 2 17.2872 2C17.7128 2 18.0564 2.33864 18.0564 2.75815V5.52793C18.0564 5.94744 17.7128 6.28608 17.2872 6.28608Z",
    fill: "#677179"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendar);
export default __webpack_public_path__ + "static/media/ico-calendar.74010fdf983dfa6ed7a93823e9f4ab14.svg";
export { ForwardRef as ReactComponent };